var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
var cls = classNames('calendar-arrow-icon');
export var CalendarArrowIconDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var CalendarArrowIcon = function CalendarArrowIcon(props) {
  var className = props.className;
  return React.createElement("svg", {
    width: "57",
    height: "69",
    viewBox: "0 0 57 69",
    fill: "none",
    className: cls.name(className)
  }, React.createElement("g", null, React.createElement("path", {
    d: "M53.35 23.76C55.09 23.76 56.5 25.26 56.5 27.11V65.07C56.5 66.92 55.09 68.42 53.35 68.42H3.65C1.91 68.42 0.5 66.92 0.5 65.07V27.11C0.5 25.26 1.91 23.76 3.65 23.76H53.35",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M8.5 38.78H48.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M8.5 49.6799H48.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M8.5 44.23H48.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M14.2202 38.78V60.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M15.5 18.99V28.31",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M28.5298 6.72998C28.3298 6.72998 28.1398 6.64998 27.9998 6.50998C27.9298 6.43998 27.8798 6.35998 27.8398 6.26998C27.7998 6.17998 27.7798 6.07998 27.7798 5.97998C27.7798 5.87998 27.7998 5.77998 27.8398 5.68998C27.8798 5.59998 27.9298 5.51998 27.9998 5.44998C28.0698 5.37998 28.1498 5.31998 28.2398 5.28998C28.4198 5.20998 28.6398 5.20998 28.8198 5.28998C28.9098 5.31998 28.9898 5.37998 29.0598 5.44998C29.1298 5.51998 29.1898 5.59998 29.2198 5.68998C29.2598 5.77998 29.2798 5.87998 29.2798 5.97998C29.2798 6.07998 29.2598 6.17998 29.2198 6.26998C29.1898 6.35998 29.1298 6.43998 29.0598 6.50998C28.9198 6.64998 28.7298 6.72998 28.5298 6.72998Z",
    fill: "#969696"
  }), React.createElement("path", {
    d: "M27.7798 16.4C27.7798 15.98 28.1198 15.65 28.5298 15.65C28.9398 15.65 29.2798 15.98 29.2798 16.4C29.2798 16.81 28.9398 17.15 28.5298 17.15C28.1198 17.15 27.7798 16.81 27.7798 16.4ZM27.7798 12.93C27.7798 12.51 28.1198 12.18 28.5298 12.18C28.9398 12.18 29.2798 12.51 29.2798 12.93C29.2798 13.34 28.9398 13.68 28.5298 13.68C28.1198 13.68 27.7798 13.34 27.7798 12.93ZM27.7798 9.44995C27.7798 9.03995 28.1198 8.69995 28.5298 8.69995C28.9398 8.69995 29.2798 9.03995 29.2798 9.44995C29.2798 9.86995 28.9398 10.2 28.5298 10.2C28.1198 10.2 27.7798 9.86995 27.7798 9.44995Z",
    fill: "#969696"
  }), React.createElement("path", {
    d: "M28.5298 20.6299C28.3398 20.6299 28.1398 20.5399 27.9998 20.3999C27.9298 20.3399 27.8798 20.2499 27.8398 20.1599C27.7998 20.0699 27.7798 19.9699 27.7798 19.8699C27.7798 19.7699 27.7998 19.6799 27.8398 19.5899C27.8798 19.4899 27.9298 19.4099 27.9998 19.3399C28.2898 19.0599 28.7798 19.0599 29.0598 19.3399C29.1998 19.4799 29.2798 19.6799 29.2798 19.8699C29.2798 20.0699 29.1998 20.2599 29.0598 20.3999C28.9198 20.5399 28.7298 20.6299 28.5298 20.6299Z",
    fill: "#969696"
  }), React.createElement("path", {
    d: "M41.5698 18.99V28.31",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M8.5 55.1199H48.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M19.9399 38.78V60.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M25.6699 38.78V60.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M31.3901 38.78V60.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M37.1201 38.78V60.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M42.8398 38.78V60.57",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M48.57 33.3301H8.5V60.5701H48.57V33.3301Z",
    stroke: "#969696",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M20.5298 8.70996L28.5298 0.709961L36.5298 8.70996",
    stroke: "#969696",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  })));
};
CalendarArrowIcon.defaultProps = CalendarArrowIconDefaultProps;
CalendarArrowIcon.cls = cls;
var templateObject_1, templateObject_2;